export default __webpack_public_path__ + "static/media/oxohome.b0b46c4f.svg";